/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import {
  selectProviderData,
  setProviderData,
} from '@vantiva-sa/homesight_humaui/Store/providerDataStore';

const useServiceProvider = ({ providerid, forceFetch = true }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [fetchingData, setFetchingData] = useState(false);

  const trans = useSelector(translator);
  const providerApi = useSelector((state) => state.apis.serviceProviderApi);
  const providerData = useSelector(selectProviderData);

  const fetchData = (forced = false) => {
    const errorCallback = (error) => {
      setFetchingData(false);
      console.error('Error fetching service provider information:', error);
      setData({});
    };
    const successCallback = (data) => {
      setFetchingData(false);
      dispatch(setProviderData(data?.serviceProvider));
      setData(data?.serviceProvider);
    };
    try {
      if (!providerid) return;
      /* check if provider data is already in store if forceFetch is not required */
      if (!forced && !forceFetch && providerData && providerData.providerid === providerid) {
        setData(providerData);
        return;
      }
      setFetchingData(true);
      providerApi.getServiceproviderById(
        providerid,
        apiCallback({
          translator: trans,
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  useEffect(() => fetchData(), [providerid]);

  return [data, fetchingData, fetchData];
};

useServiceProvider.propTypes = {
  providerid: PropTypes.string.isRequired, // ID of the service provider to fetch
  forceFetch: PropTypes.bool, // Optional: whether to force fetch from API even if data is in store
};

export default useServiceProvider;
